// features/workstations/dashboard-sections/pre-explosion-matrix.js
// ═══════════════════════════════════════════════════════════
// Pre-Explosion Matrix (Long-Term 10x)
// ═══════════════════════════════════════════════════════════
// 6-signal matrix from config.criteria.pre_explosion_signals.
// Each signal is a column. Phase 3b populates rows per company
// showing which signals have fired for which.
//
// V1: renders the header row (the 6 signals). Body shows an
// empty-state prompt pointing to the Pipeline tab.
// V2: live matrix with companies as rows, a filled/empty cell
// per signal per company.
// ═══════════════════════════════════════════════════════════

import ShiftRead from './shift-read';

export default function PreExplosionMatrixSection({ workstation }) {
  const signals = workstation?.config?.criteria?.pre_explosion_signals || [];
  if (signals.length === 0) return null;

  return (
    <section className="ws-section ws-section-pre-explosion">
      <div className="ws-section-header">
        <div className="ws-section-label">Pre-Explosion Matrix</div>
        <div className="ws-section-tag">{signals.length} signals</div>
      </div>
      <div className="ws-section-body">
        <div className="ws-matrix-table">
          <div className="ws-matrix-header">
            <div className="ws-matrix-corner">Company</div>
            {signals.map((s, i) => (
              <div key={i} className="ws-matrix-col" title={s}>
                {shortSignal(s)}
              </div>
            ))}
          </div>

          <div className="ws-matrix-empty">
            <div className="ws-matrix-empty-title">No companies scored yet</div>
            <div className="ws-matrix-empty-body">
              Add a company in the Pipeline tab. Signals fire here
              as they&rsquo;re observed in filings, earnings, and
              unit-economic data.
            </div>
          </div>
        </div>

        <div className="ws-matrix-legend">
          {signals.map((s, i) => (
            <div key={i} className="ws-matrix-legend-row">
              <span className="ws-matrix-legend-dot" />
              <span className="ws-matrix-legend-name">{s}</span>
            </div>
          ))}
        </div>

        <ShiftRead>
          2 of 6 signals is noise. 4 of 6 is a thesis. 5 of 6 with
          Sell-Side Max Bear is the setup you stop everything for.
        </ShiftRead>
      </div>
    </section>
  );
}

function shortSignal(s) {
  // Turn "Sell-Side Max Bear" → "SSMB" for header columns.
  const parts = String(s).split(/[\s-]+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 4);
  return parts.map((p) => p[0]).join('').toUpperCase().slice(0, 4);
}
